import * as firebase from 'firebase';

const auth = {
    namespaced: true,
    state: {
        user: {
            loggedIn: false,
            data: null,
            isApiUser: false,
            isSuperAdmin: false
        }
    },
    getters: {
        user: (state) => {
            return state.user;
        },
        isApiUser: (state) => {
            return state.user.isApiUser;
        },
        isSuperAdmin: (state) => {
            return state.user.isSuperAdmin;
        },
    },
    mutations: {
        SET_LOGGED_IN(state, value) {
            state.user.loggedIn = value;
        },
        SET_USER(state, data) {
            state.user.data = data;
        },
        SET_API_USER(state, data) {
            state.user.isApiUser = data;
        },
        SET_SUPER_ADMIN(state, data) {
            state.user.isSuperAdmin = data;
        }
    },
    actions: {
        fetchUser({commit}, user) {
            commit('SET_LOGGED_IN', user !== null);
            if(user) {
                commit('SET_USER', user);

                const dbRef = firebase.database().ref(`admin/${user.uid}`)
                dbRef.once('value').then((snapshot) => {
                    const result = snapshot.val();
                    if (result && 'r' in result) {
                        commit('SET_API_USER', 'api-user' in result.r && result.r['api-user']);
                        commit('SET_SUPER_ADMIN', 'superadmin' in result.r && result.r.superadmin);
                    }
                })
            } 
            else {
                commit('SET_USER', null);
            }
        }
    }
}

export default auth;